export default function generateCSSRule(selector, cssDeclaration) {
  return selector + "{" + cssDeclaration + "}";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-validator/node_modules/fela-utils/es/generateCSSRule.js
// module id = 299
// module chunks = 0